import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { customScrollStyles, FullscreenPopup } from '@gem/ui-kit';

import { withPopupLayer } from 'APP/main/Popups/withPopupLayer';

import { ArticleRedactor } from './ArticleRedactor/ArticleRedactor';
import DraftHeader from './DraftHeader';
import Header from './Header';
import usePresenter from './presenter';
import styles from './styles.m.css';

// TODO: Should Be refactoring
const Article = ({ groupId }) => {
  const { core, ref } = usePresenter({ groupId });

  return (
    <FullscreenPopup>
      {core.isLoading ? (
        <>
          {core.draft ? <DraftHeader core={core} /> : <Header core={core} />}
          <div
            ref={ref}
            className={classNames(styles.container, customScrollStyles.container)}
          >
            <div
              className={styles.content}
              data-test={'articles'}
            >
              <ArticleRedactor core={core} />
            </div>
          </div>
        </>
      ) : null}
    </FullscreenPopup>
  );
};

export default withPopupLayer(observer(Article));
